// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"antd-pro-footer-toolbar-toolbar","left":"antd-pro-footer-toolbar-left","right":"antd-pro-footer-toolbar-right"};


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/src/components/FooterToolbar/index.less
// module id = 638
// module chunks = 0